const CLIPPING_OVERFLOWS = ["auto", "scroll", "hidden", "clip"];

// The menu is not portaled, so a clipping ancestor crops it long before the window would
export const visibleBoundsOf = (element: HTMLElement) => {
  let top = 0;
  let bottom = window.innerHeight;
  for (
    let parent = element.parentElement;
    parent;
    parent = parent.parentElement
  ) {
    const { overflowY } = getComputedStyle(parent);
    if (!CLIPPING_OVERFLOWS.includes(overflowY)) continue;
    const rect = parent.getBoundingClientRect();
    top = Math.max(top, rect.top);
    bottom = Math.min(bottom, rect.bottom);
  }
  return { top, bottom };
};
